{
  "en": {
    "sortGroups": {
      "date": "Date",
      "deadline": "Deadline",
      "name": "Name"
    },
    "sorting": {
      "category_name_asc": "Category A → Z",
      "category_name_desc": "Category Z → A",
      "created_at_asc": "Oldest first",
      "created_at_desc": "Newest first",
      "deadline_date_asc": "Latest deadline first",
      "deadline_date_desc": "Earliest deadline first",
      "due_date asc": "Latest deadline first",
      "due_date desc": "Earliest deadline first",
      "group_name asc": "Name A → Z",
      "group_name desc": "Name Z → A",
      "group_name_asc": "Name A → Z",
      "group_name_desc": "Name Z → A",
      "last_name_asc": "Last Name A → Z",
      "last_name_desc": "Last Name Z → A",
      "messaged_all_at_nulls_first_asc": "Oldest first",
      "messaged_all_at_nulls_last_desc": "Newest first",
      "messaged_at_nulls_first_asc": "Oldest first",
      "messaged_at_nulls_last_desc": "Newest first",
      "name_asc": "Name A → Z",
      "name_desc": "Name Z → A",
      "name_lower asc": "Name A → Z",
      "name_lower desc": "Name Z → A",
      "name_lower_asc": "Name A → Z",
      "name_lower_desc": "Name Z → A",
      "notification_level_name_asc": "Unit A → Z",
      "notification_level_name_asc_sup": "Project A → Z",
      "notification_level_name_desc": "Unit Z → A",
      "notification_level_name_desc_sup": "Project Z → A",
      "session_started_at_asc": "Oldest session started first",
      "session_started_at_desc": "Newest session started first",
      "status asc": "Status A → Z",
      "status desc": "Status Z → A",
      "status_name_asc": "Status A → Z",
      "status_name_desc": "Status Z → A",
      "unit_name_asc": "Unit A → Z",
      "unit_name_desc": "Unit Z → A",
      "unit_name_lower_asc": "Unit A → Z",
      "unit_name_lower_desc": "Unit Z → A",
      "updated_at asc": "Oldest first",
      "updated_at desc": "Newest first",
      "updated_at_asc": "Oldest first",
      "updated_at_desc": "Newest first"
    }
  }
}
